export default __webpack_public_path__ + "static/media/avatar-user-demo.048992c2.png";